import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Chart } from 'angular-highcharts';
import { format, min, sub } from 'date-fns';
import { EarningsPerDay } from '../../../../types';

@Component({
  selector: 'lohi-driver-spark-line',
  templateUrl: './driver-spark-line.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DriverSparkLineComponent implements OnInit {
  @Input() public driverID = '';
  @Input() public earningsPerDay: EarningsPerDay[];
  @Input() public driverTarget: number | null;

  public get labels(): Array<string> {
    if (this.earningsPerDay?.length < 10) {
      let minDate = min(this.earningsPerDay.map((value) => new Date(value.date)));
      while (this.earningsPerDay.length < 10) {
        minDate = sub(minDate, { days: 1 });
        this.earningsPerDay.push({
          date: minDate.toISOString(),
          lostEarnings: 0,
          earnings: 0,
          duration: 0,
          loadsLost: 0,
          loadsCompleted: 0,
          endedShiftEarly: false,
          endedShiftEarlyMinutes: 0,
          excessDeadhead: 0,
          excessLineHaul: 0,
          excessMineTime: 0,
          excessWellTime: 0,
          timeToAccept: 0,
          rejectedMinutes: 0,
          flickedMinutes: 0,
        });
      }
    }
    return this.earningsPerDay
      ?.slice()
      .reverse()
      .map((value) => {
        return format(new Date(value.date), DATE_FORMAT, {
          useAdditionalDayOfYearTokens: true,
          useAdditionalWeekYearTokens: true,
        });
      });
  }

  public chart: Chart;

  constructor() {}

  public ngOnInit(): void {
    const plotLines = [];
    if (!!this.driverTarget) {
      plotLines.push({
        color: '#448AFF',
        dashStyle: 'Solid',
        acrossPanes: true,
        value: this.driverTarget,
      });
    }
    this.chart = new Chart({
      chart: {
        renderTo: this.driverID,
        backgroundColor: null,
        borderWidth: 0,
        type: 'column',
        margin: [2, 0, 2, 0],
        width: 100,
        height: 20,
        style: {
          overflow: 'visible',
        },
      },
      title: {
        text: '',
      },
      credits: {
        enabled: false,
      },
      xAxis: {
        categories: this.labels,
        labels: {
          enabled: false,
        },
        title: {
          text: null,
        },
        startOnTick: false,
        endOnTick: false,
        tickPositions: [],
        lineWidth: 0,
      },
      yAxis: {
        endOnTick: false,
        startOnTick: false,
        labels: {
          enabled: false,
        },
        title: {
          text: null,
        },
        plotLines,
        tickPositions: [],
      },
      legend: {
        enabled: false,
      },
      tooltip: {
        enabled: false,
      },
      plotOptions: {
        series: {
          animation: false,
          lineWidth: 1,
          shadow: false,
          states: {
            hover: {
              lineWidth: 1,
            },
          },
          marker: {
            radius: 1,
            states: {
              hover: {
                radius: 2,
              },
            },
          },
        },
        column: {
          stacking: 'overlap',
          borderColor: 'transparent',
          groupPadding: 0,
          pointPadding: 0,
          borderWidth: 0,
        },
      },
    });
    this.setupChartData();
  }

  private async setupChartData() {
    /*const lostEarnings: Array<[number | string, number | null]> = [];
    for (const date of this.earningsPerDay.slice().reverse()) {
      lostEarnings.push([
        format(new Date(date.date), DATE_FORMAT, {
          useAdditionalDayOfYearTokens: true,
          useAdditionalWeekYearTokens: true,
        }),
        date.lostEarnings as number,
      ]);
    }*/
    const earnings: Array<[number | string, number | null]> = [];
    for (const date of this.earningsPerDay.slice().reverse()) {
      earnings.push([
        format(new Date(date.date), DATE_FORMAT, {
          useAdditionalDayOfYearTokens: true,
          useAdditionalWeekYearTokens: true,
        }),
        date.earnings as number,
      ]);
    }
    /*this.chart.addSeries(
      {
        name: 'Driver Lost',
        type: 'column',
        color: '#EF6048',
        showInLegend: false,
        data: lostEarnings,
      },
      true,
      false,
    );*/
    this.chart.addSeries(
      {
        name: 'Driver',
        type: 'column',
        color: {
          linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
          stops: [
            [0, '#070707'],
            [1, '#3e3e52'],
          ],
        },
        showInLegend: false,
        data: earnings,
      },
      true,
      false,
    );
  }
}

const DATE_FORMAT = 'M/dd/yyyy hh:mm';
